import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth-provider";
import {
  getSiegeMapClears,
  SiegeMapClearEntry,
} from "@/services/siege/siege-campaign-service";
import { queryKeys } from "./query-keys";

export const useSiegeMapClears = () => {
  const { state } = useAuth();
  return useQuery({
    queryKey: queryKeys.siegeMapClears,
    queryFn: async (): Promise<SiegeMapClearEntry[]> => {
      const res = await getSiegeMapClears();
      if (!res.ok || !res.data) throw new Error(res.message);
      if (res.data.clears) return res.data.clears;
      // Fallback for older API responses during rollout.
      return (res.data.cleared_map_keys ?? []).map((map_key) => ({
        map_key,
        best_stars: 1,
      }));
    },
    enabled: state.status === "authenticated",
  });
};
